import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/** Hausrat-only icons, served from `apps/hausrat/assets/icons/`. */
export const HAUSRAT_ICONS = [
  'einfamilienhaus',
  'zweifamilienhaus',
  'doppelhaushaelfte',
  'reihenhaus',
  'mehrfamilienhaus',
] as const;

/**
 * Sparte-local icon registry, mirroring `CustomIconsService` from `@comparit/core`. The Gebäudetyp
 * house icons are Hausrat-only, so they stay in the app rather than in the shared library. Both
 * asset globs land in the same `assets/` output, so the URL shape is identical.
 */
@Injectable({
  providedIn: 'root',
})
export class HausratIconsService {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  init(): void {
    HAUSRAT_ICONS.forEach(icon => {
      this.matIconRegistry.addSvgIcon(
        `cp-${icon}`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/${icon}.svg`)
      );
    });
  }
}
